import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "react-i18next";

/**
 * A component that represents the support floating button when the current user is a guest or a normal user, not an agent
 *
 * @returns {JSX.Element}
 */

const FloatingSupportWhatsapp = ({ data }) => {
  const [t] = useTranslation("global");

  if (!data.chat) return;
  return (
    <div className="fixed z-40 bottom-5 cursor-pointer right-5 p-4 rounded-full shadow-lg transition bg-background_steel_blue text-text_white border border-text_white animate-shake">
      <a href={data.chat} target="_blank" rel="noreferrer">
        <div className="flex items-center gap-2 justify-center">
          <div>{t("about_us.bookws")}</div>
          <Icon icon="ri:whatsapp-fill" className="text-text_white text-3xl" />
        </div>
      </a>
    </div>
  );
};

export default FloatingSupportWhatsapp;
